module.exports = __webpack_public_path__ + "static/media/IELTS-AcademicReading-DragDrop1.4c1595a3.png";